import { useEffect, useState } from "react";
import { PiggyBank, ChevronDown } from "lucide-react";
import api from "@/lib/api";

const money = (n) => `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fecha = (iso) => (iso ? new Date(iso).toLocaleDateString("es-MX", { day: "2-digit", month: "short" }) : "");
const TIPO = { excedente: "Excedente de pago", faltante_recepcion: "Faltante en recepción", incidencia: "Incidencia resuelta", aplicado: "Aplicado a pedido" };

/** Saldo a favor visible para franquicias, sucursales y CEDIS, con sus movimientos. */
export default function SaldoFavorBanner({ sucursalId }) {
  const [d, setD] = useState(null);
  const [abierto, setAbierto] = useState(false);
  useEffect(() => { api.get("/saldos-favor/mio").then((r) => setD(r.data)).catch(() => {}); }, [sucursalId]);
  const saldos = (d?.saldos || []).filter((s) => !sucursalId || s.sucursal_id === sucursalId);
  const total = saldos.reduce((s, x) => s + (x.saldo || 0), 0);
  if (!saldos.length || total <= 0) return null;
  return (
    <div className="rounded-xl border border-emerald-200 bg-emerald-50/70 px-3 py-2 text-xs" data-testid="saldo-favor-banner">
      <button onClick={() => setAbierto(!abierto)} className="w-full flex items-center gap-2 text-left">
        <PiggyBank className="w-4 h-4 text-emerald-700" />
        <span className="font-bold text-emerald-900">Saldo a favor {money(total)}</span>
        <span className="text-emerald-800/80">· se descuenta automáticamente al pagar el siguiente pedido{saldos.length > 1 ? ` · ${saldos.length} sucursales` : ""}</span>
        <ChevronDown className={`w-3.5 h-3.5 ml-auto transition-transform ${abierto ? "rotate-180" : ""}`} />
      </button>
      {abierto && <div className="mt-2 space-y-1" data-testid="saldo-favor-movimientos">{saldos.map((s) => (
        <div key={s.sucursal_id}><div className="font-semibold text-emerald-900">{s.sucursal} · {money(s.saldo)}</div>{(s.movimientos || []).slice(0, 8).map((m, i) => <div key={i} className="text-[10px] text-emerald-800/80 pl-2">{fecha(m.at)} · {TIPO[m.tipo] || m.tipo} {m.folio ? `· ${m.folio}` : ""} · <span className={`font-mono ${m.monto < 0 ? "text-rose-700" : ""}`}>{m.monto > 0 ? "+" : ""}{money(m.monto)}</span>{m.nota ? ` · ${m.nota}` : ""}</div>)}</div>
      ))}</div>}
    </div>
  );
}
